import React from 'react';
import { Checkbox, Tooltip, useTooltip } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

import classname from '@search/classname/src';
import { AuthorTypeOptionsWithRealtor, LayoutImageOptions, OnlineView, PhotoOptions } from '@search/filter-enums/enums';

import { AuthorFilter, LayoutImageOptionsFilter, OnlineViewFilter, PhotoOptionsFilter } from '../../../models/Filter';

import './style.css';

const cn = classname.bind(null, 'MoreFilterView');

interface IAdditionalButtonFilter {
    photoFilter: PhotoOptionsFilter;
    onlineViewFilter: OnlineViewFilter;
    layoutImageOptionFilter: LayoutImageOptionsFilter;
    pitFilter: AuthorFilter;
    handleChange: (filter: PhotoOptionsFilter | OnlineViewFilter | LayoutImageOptionsFilter | AuthorFilter) => void;
    isLandOrHouse?: boolean;
    isNewBuilding?: boolean;
    classNameGroup?: string;
}

export const AdditionalButtonFilterView: React.FC<IAdditionalButtonFilter> = ({
    photoFilter,
    onlineViewFilter,
    layoutImageOptionFilter,
    pitFilter,
    handleChange,
    isLandOrHouse = false,
    isNewBuilding = false,
    classNameGroup
}) => {
    const { to, registerControl } = useTooltip();

    const onChangePhotoFilter = React.useCallback((newValue: boolean) => {
        if (newValue) handleChange(new PhotoOptionsFilter(PhotoOptions.WITH_PHOTO));
        else handleChange(new PhotoOptionsFilter());
    }, [ handleChange ]);

    const onChangeOnlineViewFilter = React.useCallback((newValue: boolean) => {
        if (newValue) {
            handleChange(new OnlineViewFilter(OnlineView.HAS_ANY));
        } else {
            handleChange(new OnlineViewFilter());
        }
    }, [ handleChange ]);

    const onChangeLayoutImageOptionFilter = React.useCallback((newValue: boolean) => {
        if (newValue) handleChange(new LayoutImageOptionsFilter([ LayoutImageOptions.HAS_ANY ]));
        else handleChange(new LayoutImageOptionsFilter());
    }, [ handleChange ]);

    const onChangePitFilter = React.useCallback((newValue: boolean) => {
        if (newValue) handleChange(new AuthorFilter([ AuthorTypeOptionsWithRealtor.PIT ]));
        else handleChange(new AuthorFilter());
    }, [ handleChange ]);

    return (
        <div className={classNameGroup}>
            <div className={cn('item')}>
                <Checkbox
                    name='photo'
                    value={photoFilter.photoOption === PhotoOptions.WITH_PHOTO}
                    onChange={onChangePhotoFilter}
                    variant='filter'
                    block
                >
                    Только с фото
                </Checkbox>
            </div>
            <div className={cn('item')}>
                <Checkbox
                    name='onlineView'
                    value={onlineViewFilter?.onlineView === OnlineView?.HAS_ANY}
                    onChange={onChangeOnlineViewFilter}
                    variant='filter'
                    block
                >
                    Онлайн показ
                </Checkbox>
            </div>
            {isLandOrHouse ? null : (<>
                <div className={cn('item')}>
                    <Checkbox
                        name='layout-image'
                        value={layoutImageOptionFilter.layoutImageOption.includes(LayoutImageOptions.HAS_ANY)}
                        onChange={onChangeLayoutImageOptionFilter}
                        variant='filter'
                        block
                    >
                        Только с планировкой
                    </Checkbox>
                </div>
                {/*{isNewBuilding ? null : (*/}
                {/*    <div ref={registerControl} className={cn('item')}>*/}
                {/*        <Checkbox*/}
                {/*            name='author-pit'*/}
                {/*            value={pitFilter.author.includes(AuthorTypeOptionsWithRealtor.PIT)}*/}
                {/*            onChange={onChangePitFilter}*/}
                {/*            variant='filter'*/}
                {/*            block*/}
                {/*        >*/}
                {/*            Объект имущественных торгов*/}
                {/*            <span style={{ color: '#7F78A140', marginLeft: 8 }}>*/}
                {/*                <Icon*/}
                {/*                    name='question-circle'*/}
                {/*                    size='m'*/}
                {/*                    color='black-500'*/}
                {/*                />*/}
                {/*            </span>*/}
                {/*        </Checkbox>*/}
                {/*        <Tooltip placement='body' to={to}>*/}
                {/*            Покупка имущества на&nbsp;торгах доступна как для физических, так и&nbsp;для юридических лиц,*/}
                {/*            и&nbsp;дает возможность приобрести недвижимость по&nbsp;стоимости ниже рыночной*/}
                {/*        </Tooltip>*/}
                {/*    </div>*/}
                {/*)}*/}
            </>)}
        </div>
    );
};
